import React, { Fragment } from 'react';

import {
  Modal,
  ModalContent,
  ModalContentBody,
  ModalContentFooter,
  ModalContentHeader,
  Text,
} from '@zapier/design-system';

import AsyncButton from 'app/developer-v3/components/AsyncButton';
import Link from 'app/common/components/Link';
import { PLATFORM_MARKETING_BASE_URL } from 'app/developer-v3/constants';
import { usePoweredByZapierTos } from 'app/developer-v3/hooks';

type Props = {
  onClose: () => void;
};

export default function PoweredByZapierTos({ onClose }: Props) {
  const { isLoading, renew, shouldRenew } = usePoweredByZapierTos();

  return shouldRenew ? (
    <Modal onClosed={onClose}>
      <ModalContent maxWidth="550px">
        <ModalContentHeader>
          Powered by Zapier Terms have changed
        </ModalContentHeader>
        <ModalContentBody>
          <Text tag="p" type="Body1">
            <Fragment>
              We recently updated the{' '}
              <Link
                href={`${PLATFORM_MARKETING_BASE_URL}/powered-by-zapier-terms`}
                target="_blank"
              >
                Powered by Zapier Terms
              </Link>
              . By continuing to use Powered by Zapier services, you agree to
              these updated terms.
            </Fragment>
          </Text>
        </ModalContentBody>
        <ModalContentFooter>
          <AsyncButton
            disabled={isLoading}
            isWorking={isLoading}
            onClick={() => renew()}
          >
            Continue
          </AsyncButton>
        </ModalContentFooter>
      </ModalContent>
    </Modal>
  ) : null;
}
